import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Logo from "./Logo";

export default function Preloader({ onDone }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let raf;
    const t0 = performance.now();
    const dur = 1400;
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      setCount(Math.round(p * 100));
      if (p < 1) raf = requestAnimationFrame(tick);
      else setTimeout(onDone, 400);
    };
    raf = requestAnimationFrame(tick);
    const fallback = setTimeout(onDone, 2600); // guarantee dismissal
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(fallback);
    };
  }, [onDone]);

  return (
    <motion.div
      initial={{ clipPath: "inset(0% 0% 0% 0%)" }}
      exit={{ clipPath: "inset(0% 0% 100% 0%)" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
      className="fixed inset-0 z-[110] flex flex-col items-center justify-center bg-black"
      data-testid="preloader"
    >
      <div className="overflow-hidden">
        <motion.div
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <Logo size="text-5xl md:text-7xl" showStudios />
        </motion.div>
      </div>
      <div className="absolute bottom-10 right-8 label text-white/50 tabular-nums">
        {String(count).padStart(3, "0")}
      </div>
    </motion.div>
  );
}
